import { MeetYourRooRep } from "@Roo/Common/MeetYourRooRep/MeetYourRooRep";
import { useRooTranslation } from "@Roo/Common/Wrappers/useRooTranslation";
import { isMobileDevice } from "@Roo/helpers/jsUtility";
import { Button, FlexLayout, grayBase, Heading, spacingXL } from "@RooUI";
import React from "react";

import { useRegistrationContext } from "../Common/registrationContext";

interface MeetYourRepProps {
  handleScheduleCall: () => void;
}
export const MeetYourRep = ({ handleScheduleCall }: MeetYourRepProps) => {
  const {
    registrationContext: { entityId },
  } = useRegistrationContext();
  const isMobile = isMobileDevice();

  // Calendly promo
  const { t } = useRooTranslation();

  return (
    <>
      {/* Header section */}
      <FlexLayout vertical gap="xl" style={{ marginBottom: spacingXL }}>
        <Heading level={3} color={grayBase}>
          {t("registration.meetYourRooRep.title")}
        </Heading>
      </FlexLayout>

      {/* Middle section */}
      <MeetYourRooRep vetId={entityId} />

      {/* Action section */}
      <FlexLayout
        gap="m"
        style={{ marginTop: spacingXL }}
        vertical={isMobile}
        align={isMobile ? "center" : undefined}
      >
        <Button
          $buttonType="primary"
          title="Schedule Call and View Shifts"
          onClick={handleScheduleCall}
          data-testid="scheduleActivationBtn"
        />
      </FlexLayout>
    </>
  );
};
